<template>
    <search-select :ref="`search-select_${_uid}`" v-bind="$attrs" :show-no-results="!visibleCreateForm" :options="options" label="name" :loading="loading" :placeholder="placeholder" v-on="listeners" @search-change="searchchange" @input="$emit('input', $event)">
        <template v-slot:option="{ option }">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ option.name }}</div>
                <div>{{ option.unit | unit }}</div>
            </div>
        </template>

        <template v-slot:singleLabel="{ option }">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ option.name }}</div>
                <div />
            </div>
        </template>

        <template v-if="visibleCreateForm" v-slot:afterList>
            <div class="py-3" style="background-color: rgb(249, 248, 253)">
                <div class="text-center">Быстрое создание ингредиента</div>
                <div class="text-center lead">«{{ search || 'Название' }}»</div>

                <small class="d-block text-center" :class="[error ? 'text-danger' : 'text-muted']">
                    {{ error ? error: 'Выберите единицу измерения:' }}
                </small>

                <form class="d-flex justify-content-around m-4">
                    <button v-for="unit in units" :key="unit.id" :disabled="pending || !search" type="button" class="btn btn-primary" @click.prevent="create(unit.id)">{{ unit.name }}</button>
                </form>
            </div>
        </template>
    </search-select>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SearchSelect from '@/components/Select'

import { units } from '@/components/SelectUnit'

const state = new Vue.observable({
    loaded: false,
    loading: false,
    options: []
})

export const reset = () => {
    state.loaded = false
    state.loading = false
    state.options = []
}

const fetchOptions = async _ => {
    if (state.loading || state.loaded) {
        return
    }

    state.loading = true

    try {
        const response = await axios.get('api/components', { params: { all: 1 } })

        state.options = response.data
    } finally {
        state.loaded = true
        state.loading = false
    }
}

export const remove = id => {
    const index = state.options.findIndex(option => option.id === id)

    if (index !== -1) {
        state.options.splice(index, 1)
    }
}

export const add = option => {
    state.options.unshift(option)
}

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    props: {
        placeholder: {
            type: String,
            default: 'Выберите ингредиент'
        },

        /**
         * Список ID ингредов, которые не надо показываться в выпадающем списке.
         */
        excludeIds: {
            type: Array,
            default: _ => []
        }
    },

    data() {
        return {
            search: '',
            pending: false,
            error: null
        }
    },

    computed: {
        units() {
            return units
        },

        options() {
            return state.options.filter(option => !this.excludeIds.includes(option.id))
        },

        loading() {
            return state.loading
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        },

        /**
         * Форма быстрого добавления показывается, когда:
         *
         * - Если список ингредов пуст (в т.ч. когда нет доступных ингредов, см. excludeIds)
         * - Строка поиска > 2 сиволов
         * - Строка поиска != название ингреда в списке
         */
        visibleCreateForm() {
            if (this.options.length === 0) {
                return true
            }

            const search = this.search.trim().toLowerCase()
            return search.length > 2 && this.options.findIndex(option => option.name.toLowerCase() === search) === -1
        }
    },

    async created() {
        await fetchOptions()
    },

    methods: {
        searchchange(value) {
            this.search = value
            this.error = null
        },

        async create(unitId) {
            try {
                this.pending = true

                const attributes = {
                    name: this.search,
                    unit: unitId,
                    net_price: null
                }

                const response = await axios.post('api/components', attributes)
                state.options.push(response.data)

                this.$refs[`search-select_${this._uid}`].select(response.data)
            } catch (error) {
                if (error.response.status === 422) {
                    this.error = 'Невозможно создать такой ингредиент.'
                }
            } finally {
                this.pending = false
            }
        }
    }
}
</script>
